export default __webpack_public_path__ + "static/media/working-with-us-4k.a81f0ff9.jpg";